const ldcEvents = require("js/event_helper.js");
const cardViewUtils = require("js/editor/card_view_utils.js");
const alertModule = require("js/alert.js");
const { card } = require("../css_constants");
const anchorLinkManager = require("js/editor/anchor_link_manager.js");
const utilModule = require("js/util");
const { waitForElements, highlightIfInViewPort } = require("../util");
const { danger } = require("../alert");

/**
 * The purpose of this file?
 * To move as much logic as possible related to anchor-link coordinates to here.
 *
 * So anchor links are links from Text-fragment or Argument-in-view to text-fragment
 * The source text fragment is marked with ldc-link-content.
 * The target text-fragment is always marked with ldc-link-destination.
 * The source can also be an argument in a view (which is named anchor_in_view.ex)
 *
 * if source and target-card are the same, the link is sometimes called "foot notes".
 *
 * The workflow for adding a text-fragment to text-fragment link is as follows:
 * 1. You select the source-text region and click "Link to Anchor"
 * 2. Then you choose the tar-get card, in case it's the same nothing happens, in case it's another one
 * the card will be opened
 * 3. You mark now the target text-fragment and open the froala context menu and click "Insert Anchor here".
 *
 */

const Originator = Object.freeze({
    NONE: "NONE",
    PARTNER_EDITOR: "PARTNER_EDITOR",
    // sometimes also called footnotes
    SAME_EDITOR: "SAME_EDITOR",
    VIEW: "VIEW",
});

// We need to chekc if this exists, because for static exported cards
// this is not guaranteed
if (window.ldc == null) {
    window.ldc = {};
}

window.ldc.anchorLinks = {};
window.ldc.anchorLinks.originator = Originator.NONE;

window.ldc.anchorLinks.originatorFroalaInstance = null;

window.ldc.anchorLinks.originatorArgumentId = null;
window.ldc.anchorLinks.originatorView = null;

module.exports.canInsertDestination = function () {
    return window.ldc.anchorLinks.originator != Originator.NONE;
};

/**
 * Called once the "link to Anchor"  in froala context menu (See froala.js)
 */
module.exports.afterLinkContentAdded = (froalaInstance, sourceCardId, targetCardId) => {
    console.log("After link content added: ", sourceCardId, targetCardId);

    // this is here to prevent any cascading errors
    if (sourceCardId == null) {
        alertModule.danger(froalaInstance, "This card is not saved, please save first and refresh.");
        return;
    }

    window.ldc.anchorLinks.originatorFroalaInstance = froalaInstance;

    let sameEditor = sourceCardId === targetCardId;
    if (sameEditor) {
        window.ldc.anchorLinks.originator = Originator.SAME_EDITOR;
        alertModule.info(froalaInstance, "Select the anchor in your current card.");
    } else {
        alertModule.info(
            froalaInstance,
            "Add a destination in partner editor. Mark a text and press select 'Insert Anchor here' (anchor symbol)",
        );
        window.ldc.anchorLinks.originator = Originator.PARTNER_EDITOR;

        // open the target card in partner editor
        ldcEvents.dispatch(ldcEvents.events.editInPartnerView, froalaInstance, { cardId: targetCardId });
    }
};

// called after anchor destinations has been added by froala-context menu
// replacedAnchorId is set when an existing anchor destination got a new id, the argument-links to it are removed
module.exports.afterLinkDestinationAdded = (froalaInstance, anchorId, cardId, replacedAnchorId = null) => {
    console.log("afterLinkDestinationAdded: ", window.ldc.anchorLinks);

    let originator = window.ldc.anchorLinks.originator;
    // we have two kind of anchor: the one from text to text and from view-argument to text
    if (originator === Originator.VIEW) {
        if (cardId) {
            console.log("Link with the view");

            const originalView = window.ldc.anchorLinks.originatorView;
            console.log(originalView);
            const opts = {
                id: window.ldc.anchorLinks.originatorArgumentId,
                anchorId: anchorId,
                cardId: cardId,
                replacedAnchorId: replacedAnchorId,
            };

            console.log("Add Anchor Link Destination", opts);
            originalView.pushEvent("add-anchor-link", opts);
        } else {
            alertModule.danger("Failed to add anchor, becasue card is not saved");
        }
    } else if (originator === Originator.SAME_EDITOR || originator === Originator.PARTNER_EDITOR) {
        // we link the destination card back to the originating ldc-link-content
        let originatingFroala = window.ldc.anchorLinks.originatorFroalaInstance;
        __linkAnchor(originatingFroala, cardId, anchorId);
    } else {
        console.warn("No originator found", anchorId, cardId);
    }

    console.log("Reset global variables");
    window.ldc.anchorLinks.originatorFroalaInstance = null;
    window.ldc.anchorLinks.originatorView = null;
    window.ldc.anchorLinks.originatorArgumentId = null;
    window.ldc.anchorLinks.originator = Originator.NONE;
};

// this is the context menu in views
module.exports.addAnchorLinkFeatureInView = (container, viewInstance) => {
    console.log("addAnchorLinkFeatureInView");

    // why we select by id? because the context menu exists only once
    const addAnchorMenu = container.querySelector("#view-menu-insert-anchor");
    if (addAnchorMenu) {
        addAnchorMenu.addEventListener("click", (event) => {
            // ensure that all popups are deleted
            cardViewUtils.removePopup();

            alertModule.info(document.body, "Add an anchor in your current card or a different card.");

            // somehow pass the current card-id ... we have know to which card we are linking to
            let objectId = addAnchorMenu.dataset.id;
            window.ldc.anchorLinks.originator = Originator.VIEW;
            window.ldc.anchorLinks.originatorArgumentId = objectId;

            // we have to remember this, so we can send a message to this
            window.ldc.anchorLinks.originatorView = viewInstance;

            // nothing more happens in this one, because adding an Anchor is a two-step process.
            // This is the 1. step to mark the source. The second step is to actually add the destination.
            console.log("insert anchor clicked", window.ldc.anchorLinks);
        });
    } else {
        console.log("No anchor menu link added");
    }

    // To remove the anchors, first we have to remove the destinations in the text
    // and then later we can remove the AnchorInView
    const removeAnchorMenu = container.querySelector("#view-menu-remove-anchor");
    if (removeAnchorMenu) {
        removeAnchorMenu.addEventListener("click", (event) => {
            // ensure that all popups are deleted
            cardViewUtils.removePopup();

            // remove the anchors-references in the text
            const anchorId = event.target.dataset.anchorId;
            let parentEditor = utilModule.findParentWithSelector(viewInstance.el, "#editor-container");
            anchorLinkManager.cleanupDeletedAnchorDestinations(parentEditor, anchorId);

            const opts = {
                id: event.target.dataset.id,
            };

            console.log("Remove Anchor Link Destination", opts);
            // now send to the backend to remove the anchor in the view
            viewInstance.pushEvent("remove-anchor-link", opts);
        });
    }
};

/*
 * An Anchor-link in view consist of the Source-argument in the view and the "destination ldc-link-destination tag"
 * This methods remove the referring the target tag.
 */
module.exports.cleanupDeletedAnchorDestinations = (container, anchorId) => {
    console.log("Cleanup unreferenced anchor destinations:", anchorId);
    container.querySelectorAll(`ldc-link-destination[id="${anchorId}"]`).forEach((eachViewCard) => {
        console.log("Replace anchor destination with the content", anchorId);
        eachViewCard.replaceWith(eachViewCard.innerHTML);
    });
};

/*
 * Cans the given container for ldc-link-destination tags and, per anchor id, keeps only
 * the first one (in document order). Any later element with that same id, or with no id at all,
 * gets unwrapped (replaced by its own inner content) instead of removed, so the text itself is
 * not lost - only the (now invalid) anchor tag around it.
 *
 * Why: an anchor id is supposed to mark exactly one point in the text, so a ldc-link-content tag
 * elsewhere can reliably jump to it. But froala's own editing behaviour can break that,
 * e.g. pressing Enter with the cursor in the middle of an anchor splits the paragraph in two and
 * duplicates the tag around both halves - and froala only keeps the "id" attribute on one of them,
 * leaving the other with no id. Either way, that second element no longer marks a valid, unique
 * anchor, so we clean it up here.
 */
module.exports.cleanupDuplicateAnchorDestinations = (container) => {
    const seenIds = new Set();
    container.querySelectorAll("ldc-link-destination").forEach((el) => {
        const anchorId = el.getAttribute("id");
        if (!anchorId || seenIds.has(anchorId)) {
            console.log("Duplicate or id-less anchor destination found, unwrapping copy:", anchorId);
            el.replaceWith(...el.childNodes);
        } else {
            seenIds.add(anchorId);
        }
    });
};

/**
 * For the anchors, we can have two different type of sources. Either it's a text-to-text anchor or
 * argument-to-text anchor.
 *
 * This element scroll so the correct argument (source) or text (source).
 */
module.exports.scrollToSourceAnchor = (anchorIdFound, searchArea = this) => {
    waitForElements(() => {
        const ldcLinkDestinations = searchArea.querySelectorAll(`#${CSS.escape(anchorIdFound)}`);
        const ldcLinkContents = searchArea.querySelectorAll(`[data-anchor-id='${CSS.escape(anchorIdFound)}']`);
        return [...ldcLinkDestinations, ...ldcLinkContents];
    }, 10)
        .then((highlightedElements) => {
            highlightIfInViewPort(highlightedElements);
        })
        .catch((error) => {
            console.error(error);
            danger(document, "Anchor text location not found.");
            console.log("Element not found!");
        });
};

// add "back-link" to the original from-card
function __linkAnchor(froalaInstance, cardId, anchorId) {
    // get all ldc-link-content which match the same cardId and don't have anchor id
    let linkContents = Array.from(froalaInstance.querySelectorAll("ldc-link-content")).filter((s) => {
        return s.dataset.cardid === cardId && !s.dataset.anchorId;
    });

    // we assume there is only one
    if (linkContents.length > 0) {
        const first = linkContents[0];
        console.log("add anchor id to the found ldc-link-content", first);
        first.dataset.anchorId = anchorId;
        alertModule.success(froalaInstance, "Anchor successfully added");
    } else {
        alertModule.danger(froalaInstance, "Failed to add anchor. No originating link found.");
        console.warn("LinkContentAdded in the opposite editor, but no connection found");
    }
}
